export default __webpack_public_path__ + "static/media/Hydra_Logo_Blue.ace452e5.png";